import { useEffect, useRef } from "preact/hooks";

import { useVideoAd } from "../../presentation/VideoAdContext";
import { pushAdStage } from "../../services/ad-stage-tracker";
import {
  createExcoPlayer,
  EXCO_PLAYER_ID,
  type ExcoPlayerClient,
} from "./hooks";

export default function ExcoPlayer() {
  const { session, state } = useVideoAd();
  const playerRef = useRef<ExcoPlayerClient | null>(null);

  useEffect(() => {
    let disposed = false;
    void createExcoPlayer({
      showAds: true,
      playbackMode: "click-to-play",
      mute: !state.videoVolume,
      content: {
        replacePlaylist: true,
        loop: false,
        playFirst: [
          {
            title: "Video Ad",
            src: "https://ams.cdn.arkadiumhosted.com/advertisement/video/loader_black.mp4",
          },
        ],
      },
    }).then((player) => {
      if (disposed) {
        player.destroy();
        return;
      }
      playerRef.current = player;
      player.on("player-ready", session.markPlayerLoaded);
      player.on("aderror", () => {
        pushAdStage("error");
        void session.videoError(new Error("ExCo ad error"), { player: "ExCo" });
      });
      player.on("adcomplete", () => {
        pushAdStage("completed");
      });
      player.on("slot-end", () => session.finish());
      session.markPlayerLoaded();
    }).catch(() => undefined);

    return () => {
      disposed = true;
      playerRef.current?.destroy();
      playerRef.current = null;
    };
  }, [session]);

  useEffect(() => {
    void playerRef.current?.setVolume(state.videoVolume);
  }, [state.videoVolume]);

  useEffect(() => {
    if (state.phase !== "video" || !playerRef.current) return;
    pushAdStage("ads_request");
    playerRef.current.play();
  }, [state.phase, state.videoUrl]);

  return (
    <div
      id={EXCO_PLAYER_ID}
      style={{
        opacity: state.phase === "video" ? 1 : 0,
        width: "100%",
        height: "100%",
      }}
    />
  );
}
